import { render, staticRenderFns } from "./buttonComponent.vue?vue&type=template&id=e198fe32&"
import script from "./buttonComponent.vue?vue&type=script&lang=js&"
export * from "./buttonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports